// store.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    downloadUrl:'',
    cache: {} // 存储缓存数据的状态
  },
  mutations: {
    setCache(state, { key, value }) {
      state.cache[key] = value;
    },
    clearCache(state, key) {
      if (key) {
        delete state.cache[key];
      } else {
        state.cache = {};
      }
    }
  },
  actions: {
    setCache({ commit }, payload) {
      commit('setCache', payload);
    },
    // 可以在这里定义异步操作来设置和清除缓存
    async getCache({ getters }, key) {
      // 模拟异步操作
      return getters.getCache(key);
    },
    async updateCache({ commit }, { key, value }) {

      commit('setCache', { key, value });
    }
  },
  getters: {
    // getCache: state => key => {
    //   return state.cache[key];
    // }
    getCache: (state) => (key) => {
      return state.cache[key];
    },
  }
});
